import React, { useState } from 'react';
import { change, Field, reduxForm } from 'redux-form';
import { Col, Row, Card, CardBody } from 'reactstrap';
import Tooltip from '@mui/material/Tooltip';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import PersonIcon from '@mui/icons-material/Person';
import BadgeIcon from '@mui/icons-material/Badge';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MapIcon from '@mui/icons-material/Map';
import DomainIcon from '@mui/icons-material/Domain';
import LayersIcon from '@mui/icons-material/Layers';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import MarkAsUnreadIcon from '@mui/icons-material/MarkAsUnread';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import TagIcon from '@mui/icons-material/Tag';

import renderSelectField from 'src/shared/components/form/Select';
import renderField from 'src/shared/components/form/renderField';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { showNotification } from 'src/shared/components/Notification';
import { connect } from 'react-redux';
import HubAddressChangeModal from './HubCustomerAddressChangeModal';
import HubCustomerAddNewAddress from './HubCustomerAddNewAddress';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';

const required = value => (value ? undefined : 'Required');

const HubDropOffRequiredLaterCustomerInformationInformation = ({ isCustomersId, dispatch }) => {
  const [isPopUpHubCustomer, setPopUpHubCustomer] = useState(false);
  const [isHubCustomerAddress, setHubCustomerAddress] = useState(false);
  const [hubCustomerId, sethubCustomerId] = useState(null);

  const getHubCustomersInfoById = async (id) => {
    try {
      if (id) {
        sethubCustomerId(id);
        const response = await PndRestApi.GetHubCustomerById(id);
        if (response.status === 200 && response.data.status === 200 && response.data.data.length > 0) {
          const d = response.data.data[0];
          dispatch(change('orderForm', 'toAddressShortCode', d.customerCode));
          dispatch(change('orderForm', 'toAddress', d.address));
          dispatch(change('orderForm', 'toAddressBuildingName', d.buildingName));
          dispatch(change('orderForm', 'toAddressContactNumber', d.mobileNo));
          dispatch(change('orderForm', 'toAddressPostalCode', d.poBoxNo));
          dispatch(change('orderForm', 'toAddressDoorNo', d.doorNo));
          dispatch(change('orderForm', 'toAddressFloorNo', d.floorNo));
          if (d.contactName) dispatch(change('orderForm', 'toAddressContactPersonName', d.contactName));
          dispatch(change('orderForm', 'emiratesName', d.emirates));
          dispatch(change('orderForm', 'toAddressGrlCode', d.grl));
          if (d.area) dispatch(change('orderForm', 'toAddressAreaName', d.area));
          if (d.longitude) dispatch(change('orderForm', 'toAddressLongitude', d.longitude));
          if (d.latitude) dispatch(change('orderForm', 'toAddressLatitude', d.latitude));
        } else {
          ['toAddressShortCode', 'toAddressName', 'toAddressContactNumber', 'toAddressPostalCode', 'toAddressDoorNo', 'toAddressFloorNo', 'toAddressContactPersonName', 'toAddressAreaName', 'toAddressGrlCode'].forEach(f => dispatch(change('orderForm', f, "")));
          showNotification("theme-light", "ltr", `SuccessCode: ${response.data.status}`, `Message:${response.data.message}`);
        }
      } else {
        showNotification("theme-light", "ltr", "500", "Please select Customer First");
      }
    } catch (error) {
      showNotification("theme-light", "ltr", "500", ERROR_MESSAGES.tryCatchError);
    }
  }

  return (
    <Card className="border-0 shadow-sm mb-3" style={{ background: '#f9f9f9' }}>
      <CardBody className="p-3">
        <div className="d-flex align-items-center mb-3 text-secondary border-bottom pb-2">
          <LocationOnIcon style={{ fontSize: '1.2rem' }} className="me-2 text-primary" />
          <h6 className="m-0 fw-bold small text-uppercase">Drop Off Customer Information</h6>
        </div>
        <Row className="g-2 mb-2">
          <Col lg={4} md={6}>
            <div className="mb-1">
              <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Drop Off Customer <span className='text-danger'>*</span></label>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <Field name="toAddressName" component={renderSelectField} options={isCustomersId} placeholder="Select Customer" onChange={(e) => getHubCustomersInfoById(e?.value)} validate={[required]} />
                </div>
                <Tooltip title="Add New Customer">
                  <Fab color="primary" size="small" className="ms-1" style={{ width: '30px', height: '30px', minHeight: '30px' }} onClick={() => setPopUpHubCustomer(true)}>
                    <AddIcon style={{ fontSize: '1rem' }} />
                  </Fab>
                </Tooltip>
              </div>
            </div>
          </Col>
          <Col lg={2} md={6}>
            <div className="mb-1">
              <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Customer Code</label>
              <Field name="toAddressShortCode" component={renderField} type="text" placeholder="Code" icon={BadgeIcon} disabled={true} />
            </div>
          </Col>
          <Col lg={6} md={12}>
            <div className="mb-1">
              <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Drop Off Address <span className='text-danger'>*</span></label>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <Field name="toAddress" component={renderField} type="textarea" placeholder="Address and Remarks" validate={[required]} icon={LocationOnIcon} />
                </div>
                <Tooltip title="Change Address">
                  <Fab color="primary" size="small" className="ms-1" style={{ width: '30px', height: '30px', minHeight: '30px' }} onClick={() => setHubCustomerAddress(true)}>
                    <EditIcon style={{ fontSize: '1rem' }} />
                  </Fab>
                </Tooltip>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="g-2 mb-2">
          <Col lg={2} md={4}>
            <div className="mb-1">
              <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>GRL</label>
              <Field name="toAddressGrlCode" component={renderField} type="text" placeholder="GRL" disabled icon={TagIcon} />
            </div>
          </Col>
          <Col lg={4} md={8}>
            <div className="mb-1">
              <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Area <span className='text-danger'>*</span></label>
              <Field name="toAddressAreaName" component={renderField} type="text" placeholder="Area" validate={[required]} icon={MapIcon} />
            </div>
          </Col>
          <Col lg={6} md={12}>
            <div className="mb-1">
              <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Building Name <span className='text-danger'>*</span></label>
              <Field name="toAddressBuildingName" component={renderField} type="text" placeholder="Building Name" validate={[required]} icon={DomainIcon} />
            </div>
          </Col>
        </Row>
        <Row className="g-2">
          <Col lg={2} md={4}>
            <div className="mb-1">
              <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Floor No. <span className='text-danger'>*</span></label>
              <Field name="toAddressFloorNo" component={renderField} type="text" placeholder="Floor" validate={[required]} icon={LayersIcon} />
            </div>
          </Col>
          <Col lg={2} md={4}>
            <div className="mb-1">
              <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Door No. <span className='text-danger'>*</span></label>
              <Field name="toAddressDoorNo" component={renderField} type="text" placeholder="Door" validate={[required]} icon={MeetingRoomIcon} />
            </div>
          </Col>
          <Col lg={2} md={4}>
            <div className="mb-1">
              <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Postal Code</label>
              <Field name="toAddressPostalCode" component={renderField} type="text" placeholder="Zip" icon={MarkAsUnreadIcon} />
            </div>
          </Col>
          <Col lg={3} md={6}>
            <div className="mb-1">
              <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Contact Name</label>
              <Field name="toAddressContactPersonName" component={renderField} type="text" placeholder="Person" icon={PersonIcon} />
            </div>
          </Col>
          <Col lg={3} md={6}>
            <div className="mb-1">
              <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Mobile No. <span className='text-danger'>*</span></label>
              <Field name="toAddressContactNumber" component={renderField} type="text" placeholder="971xxxxxxx" validate={[required]} icon={SmartphoneIcon} />
            </div>
          </Col>
        </Row>
        {isHubCustomerAddress && hubCustomerId && (
          <HubAddressChangeModal modalShow={isHubCustomerAddress} setModalShow={setHubCustomerAddress} isTitle={"Change Hub Customer Address"} hubCustomerId={hubCustomerId} />
        )}
        {isPopUpHubCustomer && (
          <HubCustomerAddNewAddress modalShow={isPopUpHubCustomer} setModalShow={setPopUpHubCustomer} isTitle={"Add New Hub Customer Address"} />
        )}
      </CardBody>
    </Card>
  );
};

export default connect()(reduxForm({
  form: "orderForm",
  enableReinitialize: false,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
})(HubDropOffRequiredLaterCustomerInformationInformation));
